import { MEMBERS, MEMBERS_ABOUT, MEMBERS_ACCOUNT_INFO, MEMBERS_AREA_V2, MEMBERS_FOLLOWERS, MY_ADDRESSES, MY_REWARDS, MY_SUBSCRIPTIONS, MY_WALLET, NOTIFICATIONS, SETTINGS, WIX_BLOG, WIX_BOOKINGS, WIX_CHALLENGES, WIX_EVENTS, WIX_FILE_SHARE, WIX_FORUM, WIX_GROUPS, WIX_STORES, } from '@wix/app-definition-ids';
export const AppDefinitionId = {
    About: MEMBERS_ABOUT,
    MyAccount: MEMBERS_ACCOUNT_INFO,
    Members: MEMBERS,
    Blog: WIX_BLOG,
    FileShare: WIX_FILE_SHARE,
    Followers: MEMBERS_FOLLOWERS,
    Forum: WIX_FORUM,
    Addresses: MY_ADDRESSES,
    Bookings: WIX_BOOKINGS,
    Events: WIX_EVENTS,
    Stores: WIX_STORES,
    Wallet: MY_WALLET,
    Notifications: NOTIFICATIONS,
    Settings: SETTINGS,
    SharedGallery: '476dc2dd-e16e-43b0-a0aa-1a486c78fbe2',
    Subscriptions: MY_SUBSCRIPTIONS,
    ProfilePageBob: MEMBERS_AREA_V2,
    Programs: WIX_CHALLENGES,
    Rewards: MY_REWARDS,
    Groups: WIX_GROUPS,
    TestVertical: '567d5e7e-4224-4488-a24b-d1ee5f691e54',
};
//# sourceMappingURL=app-definition.js.map